import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { AmbulanceBooking } from "../ambulanceBooking/AmbulanceBooking";
import style from "../../../pages/ticketHandlingPart2/ticketHandlingPart2.module.scss";
import { UseGetStoreData } from "../../../hooks/getStoreData/UseGetStoreData";
interface LogisticsAmbulanceDoctorTabProps {
  handleBookAmbulance: any;
  getTicketStatus: string;
  handleCloseTicket: any;
  handleDemoCloseTicket: any;
  getPatientPickupAddress: any;
  getPatientPickupCity: string;
  getPatientDropLocation: any;
  pickupLocationLabel: string;
}
export const Ambulance: React.FC<
  LogisticsAmbulanceDoctorTabProps
> = ({
  handleBookAmbulance,
  getTicketStatus,
  handleCloseTicket,
  handleDemoCloseTicket,
  getPatientPickupAddress,
  getPatientPickupCity,
  getPatientDropLocation,
  pickupLocationLabel,
}) => {
  const { getTicketMedicalStatus } = UseGetStoreData();
  return (
    <BackgroundWrapper className={style.background}>
      <Container className={`${style.wrapper} ${getTicketMedicalStatus?.isAmbulanceRequired === "Yes" ? style.single : ""}`}>
        <Container className={style.ambulance_component}>
          <Text className={style.heading} text="Ambulance" />
          <AmbulanceBooking
            label={pickupLocationLabel}
            pickupLocation={getPatientPickupAddress}
            pickupCity={getPatientPickupCity}
            dropLocation={getPatientDropLocation}
          />
        </Container>
      </Container>
    </BackgroundWrapper>
  );
};
